import styled from 'styled-components';


const DefaultTitle = styled.h2<{ color?: string, align?: string }>`
  color: ${({ theme, color }) => color ?? theme.colors.white};
  text-transform: uppercase;
  font-family: 'Impact', sans-serif;
  font-weight: 400;
  margin-bottom: 30px;
  letter-spacing: 0.09em;
  text-align: ${({ align }) => align ?? 'center'};
  font-size: ${({ theme }) => theme.headingSize.small};
  @media(min-width: ${({ theme }) => theme.screenSizeWidth.medium}){
    font-size: ${({ theme }) => theme.headingSize.medium};
  }
`;

export default DefaultTitle;
